module.exports = __webpack_public_path__ + "static/img/overview.5a0597ee.svg";